import { createRecipe } from './runtime.js';

const separatorConfig = {"name":"separator","defaultVariants":{"type":"verticalBar"},"variantMap":{"type":["dot","horizontalBar","verticalBar"]}}

export const separator = /* @__PURE__ */ createRecipe(separatorConfig)